import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import { memberPortal } from "../member-portal";
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";
require('datatables.net');
require('parsley');
require('datatablesResponsive');

export class memberNominee {
	private nomineeForm: any = $('#nominee-mob');
	private newNomineeValidation: any = $('#member-nominee-registration-userrequest');
	$scope: any = $('#nominee-mob');
	private memberBase: any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	nomineeData:any;
	hiddenSubmissionID:any;
	nomineesOptionsData:any;
	private enableIniCheckBox:any;
	

	initTextInputs(): any {
		let _self = this;
		let inputElArr: any = $.makeArray(_self.newNomineeValidation.find('input[type="text"], input[type="select"], input[type="file"]'));
		_self.memberBase.initFormTextInputs(inputElArr);
	}
	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.newNomineeValidation, function (validation: any) {
			// all your custom validation here

			// $('#enrich-voucher--redemption-receipt-amount').attr('step', '0.01');
			// $('#enrich-voucher--redemption-receipt-amount').attr('placeholder', '00.00');
		});
		// _self.memberBase.validateForm(_self.goldRdmForm1, function (validation: any) {
		// 	// all your custom validation here
		// });
		// _self.memberBase.validateForm(_self.goldRdmForm2, function (validation: any) {
		// 	// all your custom validation here
		// });
	}
	populateNominees(): any {
		let _self = this;
		//let nomineeTab = $("[href='#nominee']");
		let nomineeurl: any;
		let sponsoreurl: any;
		var nomineesList = $.Deferred();
		var sponsorsList = $.Deferred();
		//nomineeTab.click(function () {
			// Handle Add traveller button visibility in mobile.
			//$(this).parents('ul').addClass('mytrav-inactive');

			if (window.location.hostname === 'localhost' && window.location.port == '5000') {
				nomineeurl = '/dummy-data/membernominees.json';
				sponsoreurl = '/dummy-data/membersponsors.json';
			}
			else {
				nomineeurl = '/bin/services/new/getNomineeLCP';
				sponsoreurl = '/bin/services/new/getSponsersLCP';
			}
			//fetch member nominees
			_self.bookingformcommon.preloader();
			$.get(nomineeurl)
				.done((data: any) => {
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
					_self.bookingformcommon.preloaderClose();
					nomineesList.resolve(data.nomineeRespList);
					_self.nomineeData = data.nomineeRespList;
					_self.nomineesOptionsData = data.nomineeRespList;
				})
				.fail((error: any) => {
					nomineesList.reject(error)
				});
			//fetch member sponsors
			$.get(sponsoreurl)
				.done((data: any) => {

					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
					sponsorsList.resolve(data.sponserRespList);
				})
				.fail((error: any) => {
					sponsorsList.reject(error)
				});
		//})

		$.when(nomineesList, sponsorsList).done(function (nominees: any, sponsors: any) {
			// console.log("API done",nominees,sponsors);
			$(".members--nominee--form .number-of-nominees").html(nominees.length);
			let nomineeTable = $("#nominee-table")

			$(".member--sponsors .number-of-nominees").html(sponsors.length);
			let sponsorsTable = $("#sponsor-table")

			if (nominees.length === 0) {
				nomineeTable.hide();
				$(".members--nominee--form .description").hide();
				$(".members--nominee--form .no-data-description").removeClass('hide');
			}
			else {
				_self.populateTable(nomineeTable, nominees, true);
			}
			if (sponsors.length === 0) {
				sponsorsTable.hide();
				$(".member--sponsors .no-data-description").removeClass('hide');
				$(".sponsers-description").hide();
			}
			else {
				_self.populateTable(sponsorsTable, sponsors, false);
				$(".member--sponsors #sponsor-table tbody tr > td:last-child").addClass('hide-col');
			}
		});
		// Handle Add traveller button visibility in mobile.
		$("[href='#member-myadd-lcptraveller']").click(function () {
			$(this).parents('ul').removeClass('mytrav-inactive');
		})
	}
	populateTable(tableElm: any, tableData: any, canDeactivate: boolean): any {
		let _self = this;

		tableElm.DataTable({
			data: tableData,
			info: false,
			bLengthChange: false,
			paging: false,
			ordering: false,
			responsive: false,
			// $.fn.dataTable.ext.errMode = 'none',
			"columns": [
				{
					//"title": "Nominee ID",
					"data": function (row: any, type: string, val: any, meta: string) {
						if (row.hasOwnProperty('sponserId')) {
							return row['sponserId']
						}
						return row['nominneId'];
					}
				},
				{ //"title": "Name",
					"data": function (row: any, type: string, val: any, meta: string) {
						return row["name"];
					}
				},
				{ //"title": "Start Date",
					"data": function (row: any, type: string, val: any, meta: string) {
						return row['startDate'];
					},
					// "render": function(data:any,type:any,row:any){
					// 	return moment(data,'YYYY-MM-DD').format('DD/MM/YYYY');
					// }
				},
				{ //"title": 'End Date',
					"data": function (row: any, type: string, val: any, meta: string) {
						return row['enddate'];;
					},
					// "render": function(data:any,type:any,row:any){
					// 	return moment(data,'YYYY-MM-DD').format('DD/MM/YYYY');
					// }
				},
				{ //"title": 'status',
					"data": function (row: any, type: string, val: any, meta: string) {
						if (canDeactivate && row['status'].toLowerCase() === 'active') {
							return `<td rowspan="1" colspan="1"> <span class="nominee-status">Active</span>
									<div class="form-item">
                                  <label class="label" for="nominee-status-deactivate">
                                  </label>
                                  <select class="nominee-status-deactivate" id="nominee-status-deactivate" data-parsley-errors-container="#nominee-status-deactivate--error-container" onfocus="blur();">
                                    <option value="">
                                    </option>
                                    <option value="Deactivate">Deactivate
                                    </option>
                                  </select>
                                  <div class="error_msg" id="nominee-status-deactivate--error-container"></div>
                                </div>
								  </td>`;
						}
						if (canDeactivate && row['status'].toLowerCase() === 'deactivated') {
							return `<td rowspan="1" colspan="1"> <span class="nominee-status">Deactivated</span>
									<div class="form-item">
                                  <label class="label" for="nominee-status-deactivate">
                                  </label>
                                  <select class="nominee-status-deactivate" id="nominee-status-deactivate" data-parsley-errors-container="#nominee-status-deactivate--error-container" onfocus="blur();">
                                    <option value="">
                                    </option>
                                    <option value="Activate">Activate
                                    </option>
                                  </select>
                                  <div class="error_msg" id="nominee-status-deactivate--error-container"></div>
                                </div>
								  </td>`;
						}
						return row['status'];
					}
				},
				
				{ //"title": 'Pool Status'
					"data": function (row: any, type: string, val: any, meta: string) {
						if (row.hasOwnProperty('sponserId')) {
							return `<a style="display: none;">pool</a>`;
						}
						if(row['poolStatus'] != "joinPool"){
							return row['poolStatus'];
						}else{
							return `<a href="" class="join-pool btn btn-primary">Add to Pool</a>`;
							//  _self.popupHandling();
						}
					},
					// "render": function(data:any,type:any,row:any){
					// 	return moment(data,'YYYY-MM-DD').format('DD/MM/YYYY');
					// }
				},

			],
			initComplete: function (settings: any, json: any) {
				_self.handleNomineeStatus();
				_self.handleOverflow();
				_self.popupHandling();
			}
		});
	}
	popupHandling(): any {
		
		var _self = this;
		// $('#nominee-table').on('click','.join-pool',function()
		// $(document).load(function(){
			
		// });
		$("#nominee-table tbody tr .join-pool").click(function ($instance: any){
			$instance.preventDefault();
			var currentRow =$(this).closest("tr");
			// var currentRow=$('#nominee-table t').closest("tr");
            var nomineeId=currentRow.find("td:eq(0)").html();
			_self.bookingformcommon.preloader();
			$.magnificPopup.open({
				items: {
					src: '#nominee-join-pool-popup'
				},
				type: 'inline',
				midClick: true,
				enableEscapeKey: false,
				showCloseBtn: false,
				closeOnBgClick: false,
				modal: true,
				callbacks: {
					open: function () {
						var $content = $(this.content);
						_self.bookingformcommon.preloaderClose();
						$('#member--nominee-popup-submit').attr('disabled', true);
			var popupfields = $("#nominee-join-pool-popup");
			$(popupfields, 'input select file').on("keyup change", function(e:any) {
				var filled = false;
				$(this).find(":input").each(function() {
					var popupfield = $("#member--nominee-popup-relationship").val();
					var popupfield1 = $("#member--nominee-popup-contribution").val();
					var popupfield2 = $("#member--nominee-upload-popup").val();
					var popupAckCheckbox = $("#acknowledge-popup");
					
						if (((popupfield && popupfield1 && popupfield2) != "") && ((popupAckCheckbox.is(":checked")))){
							$('#member--nominee-popup-submit').attr('disabled', false);
						}else{
							$('#member--nominee-popup-submit').attr('disabled', true);
						}
				});
			  });
						$content.on('click', '#member--nominee-popup-submit', function () {
							$.magnificPopup.close();
							// _self.handlingPopupData();
							let memberNomineePopupRelationship = $('#member--nominee-popup-relationship');
							let memberNomineePopupContribution = $('#member--nominee-popup-contribution');
							let memmemberNomineeUploadPopup= $('#member--nominee-upload-popup');
							let submitButton = $('#member--nominee-popup-submit');
							let cancelButton = $('#member--nominee-popup-cancel');
							let action = 'joinPool';
							_self.bookingformcommon.preloader();
							// let jsonData = '';/
							
							// $('#member--nominee-popup-submit').click(function(){
								// let relationValue = memberNomineePopupRelationship.val();
								// let contributionValue = memberNomineePopupContribution.val();
								// var currentRow=$(this).closest("tr");
								// var nomineeId=currentRow.find("td:eq(0)").html();
								// let data={
								// 	relationship : relationValue,
								// 	contribution : contributionValue,
								// 	nomineeID : nomineeId,
								// }
						// }
								var form = $('#member-nominee-join-pool-popup')[0];
					
									var formData = new FormData(form);
									formData.append('action',action);
									formData.append('nomineeId',nomineeId);
									formData.append('source_submit','Pool-App');
									let authenticationUrl: string = '';
									
									_self.bookingformcommon.preloader();
					
									if (window.location.hostname === 'localhost' && window.location.port == "5000") {					
										authenticationUrl = '/dummy-data/newNomineeStatus.json';				
									}					
									else {					
										authenticationUrl = '/bin/services/new/saveNomineeDtls';					
									}
								$.ajax({
									method: 'POST',
									url: authenticationUrl,
									data: formData,
									processData: false,
									contentType: false,
									success: function (msg: any) {
										_self.bookingformcommon.preloaderClose();
										if (msg != "") {
											var json = msg;
											if (typeof msg === 'string') {
												json = JSON.parse(msg);
											}
										if (json.processCode === "OK") {
											$.magnificPopup.open({
												items: {
													src: '#enhancement-nomine-success-popup-msg'
												},
												type: 'inline',
												midClick: true,
												enableEscapeKey: false,
												showCloseBtn: false,
												closeOnBgClick: false,
												modal: true,
												callbacks: {
													open: function () {
														var $content = $(this.content);
														$content.on('click', '.msg-btn-cancel', function () {
															$.magnificPopup.close();
															//location.reload();
														});
													}
												}
											}, 0);
				
										} else {
				
											$('body').animate({
				
												'scrollTop': 100
				
											}, 500, function () { });
											$.magnificPopup.open({
												items: {
													src: '#enhancement-nominee-failure-popup-msg'
												},
												type: 'inline',
												midClick: true,
												enableEscapeKey: false,
												showCloseBtn: false,
												closeOnBgClick: false,
												modal: true,
												callbacks: {
													open: function () {
														var $content = $(this.content);
														$content.on('click', '.msg-btn-cancel', function () {
															$.magnificPopup.close();
														});
													}
												}
											}, 0);
				
										}
									}
										// let nominees = data.nomineeRespList
										// if (nominees.length === 0) {
										// 	// nomineeTable.hide();
										// 	$(".members--nominee--form .description").hide();
										// 	$(".members--nominee--form .no-data-description").removeClass('hide');
										// }
										// else {
										// 	// let table = nomineeTable.DataTable()
										// 	// table.clear().draw();
										// 	// table.rows.add(nominees)
										// 	// table.columns.adjust().draw()
										// 	// _self.handleNomineeStatus();
										// }
									},
									error: function (msg: any) {
										_self.bookingformcommon.preloaderClose();
									}
								});
					
							

						});

						$content.on('click', '#member--nominee-popup-cancel', function () {
							$.magnificPopup.close();
							//$.magnificPopup.clear();
						});
					}
				}
			}, 0);
		});
	}
	handlingPopupData():any{
	// 	let _self = this;
	// 	let memberNomineePopupRelationship = $('#member--nominee-popup-relationship');
	// 	let memberNomineePopupContribution = $('#member--nominee-popup-contribution');
	// 	let memmemberNomineeUploadPopup= $('#member--nominee-upload-popup');
	// 	let submitButton = $('#member--nominee-popup-submit');
	// 	let cancelButton = $('#member--nominee-popup-cancel');
	// 	// let jsonData = '';/
		
	// 	// $('#member--nominee-popup-submit').click(function(){
	// 		// let relationValue = memberNomineePopupRelationship.val();
	// 		// let contributionValue = memberNomineePopupContribution.val();
	// 		// var currentRow=$(this).closest("tr");
    //         // var nomineeId=currentRow.find("td:eq(0)").html();
	// 		// let data={
	// 		// 	relationship : relationValue,
	// 		// 	contribution : contributionValue,
	// 		// 	nomineeID : nomineeId,
	// 		// }
	// // }
	// 		var form = $('#member-nominee-join-pool-popup')[0];

    //             var formData = new FormData(form);
	// 			let authenticationUrl: string = '';
				
    //             // _self.bookingformcommon.preloader();

    //             if (window.location.hostname === 'localhost' && window.location.port == "5000") {

    //                 authenticationUrl = '/dummy-data/membernominees.json';

    //             }

    //             else {

    //                 authenticationUrl = '/bin/services/new/saveNomineeDtls';

    //             }
			
	// 		$.ajax({
	// 			method: 'GET',
	// 			url: authenticationUrl,
	// 			data: formData,
	// 			processData: false,
    //             contentType: false,
	// 			success: function (msg: any) {
	// 				_self.bookingformcommon.preloaderClose();
	// 				var json = msg;
	// 				alert(msg);
	// 				if (typeof msg === 'string') {
	// 					json = JSON.parse(msg);
	// 				}else{
	// 					json = formData;
	// 				}
	
	// 				// let nominees = data.nomineeRespList
	// 				// if (nominees.length === 0) {
	// 				// 	// nomineeTable.hide();
	// 				// 	$(".members--nominee--form .description").hide();
	// 				// 	$(".members--nominee--form .no-data-description").removeClass('hide');
	// 				// }
	// 				// else {
	// 				// 	// let table = nomineeTable.DataTable()
	// 				// 	// table.clear().draw();
	// 				// 	// table.rows.add(nominees)
	// 				// 	// table.columns.adjust().draw()
	// 				// 	// _self.handleNomineeStatus();
	// 				// }
	// 			},
	// 			error: function (msg: any) {
	// 				_self.bookingformcommon.preloaderClose();sg
	// 			}
	// 		});

	

	}
	handleNomineeStatus(): any {
		let _self = this
		$(".selectize-control.nominee-status-deactivate input").attr('readonly', true);
		$("select.nominee-status-deactivate").selectize({
			onChange: function (value: any) {
				var _current = this
				let selectedNomineeId = $($(this)[0].$input["0"]).closest('tr').children('td:first').text()
				if (value === 'Deactivate') {

					$.magnificPopup.open({
						items: {
							src: '#nominee-deactivate-popup'
						},
						type: 'inline',
						midClick: true,
						enableEscapeKey: false,
						showCloseBtn: false,
						closeOnBgClick: false,
						modal: true,
						callbacks: {
							open: function () {
								var $content = $(this.content);

								$content.on('click', '.msg-btn-confirm', function () {
									$.magnificPopup.close();
									//call api to delete the message
									_self.nomineeStatusAPI(selectedNomineeId, 'Deactivated')
								});

								$content.on('click', '.msg-btn-cancel', function () {
									$.magnificPopup.close();
									_current.clear()
								});
							}
						}
					}, 0);

				}
				if (value === 'Activate') {
					$.magnificPopup.open({
						items: {
							src: '#nominee-activate-popup'
						},
						type: 'inline',
						midClick: true,
						enableEscapeKey: false,
						showCloseBtn: false,
						closeOnBgClick: false,
						modal: true,
						callbacks: {
							open: function () {
								var $content = $(this.content);

								$content.on('click', '.msg-btn-confirm', function () {
									$.magnificPopup.close();
									//call api to delete the message
									_self.nomineeStatusAPI(selectedNomineeId, 'Active')
								});

								$content.on('click', '.msg-btn-cancel', function () {
									$.magnificPopup.close();
									_current.clear()
								});
							}
						}
					}, 0);
				}
			}
		});
	}

	nomineeStatusAPI(nomineeId: any, newStatus: any): any {
		let _self = this
		let deactivateUrl = '/bin/services/new/deactivateNomineeLCP'
		let nomineeTable = $("#nominee-table")
		let nominee = _self.nomineeData.find((elm: any) => elm.nominneId == nomineeId)
		nominee['status'] = newStatus;
		let jsonData = nominee;
		_self.bookingformcommon.preloader();
		// console.log(jsonData)
		$.ajax({
			url: deactivateUrl,
			method: 'POST',
			data: jsonData,
			success: function (data: any) {
				_self.bookingformcommon.preloaderClose();
				if (typeof data === 'string') {
					data = JSON.parse(data);
				}

				let nominees = data.nomineeRespList
				if (nominees.length === 0) {
					nomineeTable.hide();
					$(".members--nominee--form .description").hide();
					$(".members--nominee--form .no-data-description").removeClass('hide');
				}
				else {
					let table = nomineeTable.DataTable()
					table.clear().draw();
					table.rows.add(nominees)
					table.columns.adjust().draw()
					_self.handleNomineeStatus();
				}
			},
			error: function (msg: any) {
				_self.bookingformcommon.preloaderClose();
			}
		});


	}
	handleOverflow(): any {
		$(".member-nominees-container table").each(function () {
			if ($(this).width() > $(".member-nominees-container").width()) {
				$(this).addClass('overflow');
				$(this).parents(".member-nominees-container").addClass('overflow');
			}
		})
		//$('a[href="#nominee"]').on('shown.bs.tab', function () {
			$(".member-nominees-container table").each(function () {
				if ($(this).width() > $(".member-nominees-container").width() && !$(this).hasClass('overflow')) {
					$(this).addClass('overflow');
					$(this).parents(".member-nominees-container").addClass('overflow');
				}
			})
		//});

	}
	nomineeCheckboxBasedShowAndhideForm(): any {
		$('.checkbox_trigger').change(function () {
			var hiddenId = $(this).attr("data-trigger");
			var hiddenis123 = $(this).attr('id');
			if ($(this).is(':checked')) {
				$("." + hiddenId).removeClass('hide');
			} else {
				$("." + hiddenId).find('select,input').val("");
				$("." + hiddenId).addClass('hide');
			}
		});
	}
	nomineeTypeBasedshowhide(): void {
		let _self = this;
		$('.member-current--nomineeenrichid').hide();
		var optValue = "Replacement";
		$('select').change(function () {
			var cureentFormDataIdforhide = $(this).attr('id');
			var cureentFormDataId = $(this).attr('id').slice(-1);
			let selectedparent = $(this).parents("fieldset");
			let slectedvalue = this.value;
			$(selectedparent).find('select').each(function () {
				if (slectedvalue == "" || slectedvalue == "New") {
					selectedparent.find(".member-current--nomineeenrichid").hide();
					$("#member-current--currentenrichid" + cureentFormDataId).val("");
					$("#member-nominee-registration-userrequest .error-validation").html("");
					$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
					$("#member-nominee-registration-userrequest .error-validation").removeClass('mandatory-text');
				}
				// else if(nominees.length == 0){
				// 	$("select option:contains('Value " + optValue + "')").attr("disabled","disabled");
				// }
				else if (slectedvalue == "Replacement") {
					selectedparent.find('.member-current--nomineeenrichid').show();
					//drop-down id append 
					let nominees = _self.nomineeData;
					let nomineesLength = nominees.length;
					if (nomineesLength == 0) {
						$("select option:contains('Value " + optValue + "')").attr('disabled', true);
						selectedparent.find('.member-current--nomineeenrichid').hide();
						$("#member-nominee-registration-userrequest .error-validation").html("Nominees Not Found Please Check/Select Option New");
						$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
						$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
						$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');

					}
				}
			});
		});
	}
	addNewNominee(): void {
		let _self = this;
		let uniqueId = 1;
		$('#add-newnomineeform--button').click(function (event: any) {
			event.preventDefault();
			let fieldsetlength = $("#nominee-form-filedset").children('fieldset').length;
			let showedfieldsets = $("#nominee-form-filedset").children('fieldset').not("." + 'hide').length;
			if (showedfieldsets == 8) {
				$('.addnewnominee').addClass('hide');
				$('.submitallsavednominees').removeClass('hide');
			} else {
				$("#new-nominee" + (showedfieldsets + 1)).removeClass('hide');
				$(".nominee-requestform--submit").addClass('hide');
				//$("#new-nominee" + (showedfieldsets + 1)).trigger('click');
			}
			var checkinputvalue = $("#new-nominee" + (showedfieldsets + 1));
			$('.add-nomineeform--button' + showedfieldsets).attr('disabled', true);
			var firstinputval123 = $("#new-nominee" + (showedfieldsets + 1));
			$(firstinputval123, 'input select file').on("keyup change", function(e:any) {
				var filled = false;
				$(this).find(":input").each(function() {
					var testfield = $("#member--nominee-type" + showedfieldsets).val();
					var testfield1 = $("#member-nominee--enrichid" + showedfieldsets).val();
					var testfield2 = $("#member-current--currentenrichid" + showedfieldsets).val();
					var testfield3 = $("#member--nominee-upload" + showedfieldsets).val();
					var testfieldCheckbox = $("#freinds-familynominee" + showedfieldsets);
					var testfield4 = $("#member--nominee-relation" + showedfieldsets).val();
					var testfield5 = $("#member--nominee-contri" + showedfieldsets).val();
					var testfield6 = $("#member--nominee-signedconsent" + showedfieldsets).val();
					if(testfield == "Replacement"){
						if (((testfield && testfield1 && testfield2 && testfield3) != "") && ((testfieldCheckbox.is(":checked")) && ((testfield4 && testfield5 && testfield6) != ""))){
							$('.add-nomineeform--button' + showedfieldsets).removeAttr('disabled', true);
						} else if(((testfield && testfield1 && testfield2 && testfield3) != "") && (testfieldCheckbox.is(":not(:checked)"))){
							$('.add-nomineeform--button' + showedfieldsets).removeAttr('disabled', true);
						} else {
							$('.add-nomineeform--button' + showedfieldsets).attr('disabled', true);
						}
					} else {
						if (((testfield && testfield1 && testfield3) != "") && ((testfieldCheckbox.is(":checked")) && ((testfield4 && testfield5 && testfield6) != ""))){
							$('.add-nomineeform--button' + showedfieldsets).removeAttr('disabled', true);
						} else if(((testfield && testfield1 && testfield3) != "") && (testfieldCheckbox.is(":not(:checked)"))){
							$('.add-nomineeform--button' + showedfieldsets).removeAttr('disabled', true);
						} else {
							$('.add-nomineeform--button' + showedfieldsets).attr('disabled', true);
						}
					}
				});
			  });
		});
	}
	enableCheckBoxs(): void {
		let _self = this;
		// var id = $(this).parent().attr("id");
		// alert('id');
		$("#member-nominee-registration-userrequest .error-validation").html("");
		$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
		$("#member-nominee-registration-userrequest .error-validation").removeClass('mandatory-text');
		// var cureentFormDataIdforhide = $(this).attr('id');
		// var cureentFormDataId = $(this).attr('id').slice(-1);
		// let parentidfordisabeinputs= $("#" + cureentFormDataIdforhide).parent('fieldset').attr('id');
		// let currentId=$(this).attr("id").slice(-1);
		var form = $('#member-nominee-registration-userrequest')[0];
		var formData = new FormData(form);
		// formData.append("cureentFormDataId", cureentFormDataId);
		// formData.append("submissionID", $('#submissionID').val());
		// formData.append("nomineeID", $('#member-nominee--enrichid'+cureentFormDataId).val());
		let authenticationUrl: string = '';
		_self.bookingformcommon.preloader();
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			authenticationUrl = '/dummy-data/newNomineeStatus.json';
		}
		else {
			authenticationUrl = '/bin/services/new/getFFPoolDtls';
		}
		$.ajax({
			type: 'GET',//Change to POST if required
			url: authenticationUrl,
			data: formData,
			processData: false,
			contentType: false,
			success: function (msg: any) {
				_self.bookingformcommon.preloaderClose();
				if (msg != "") {
					var json = msg;
					if (typeof msg === 'string') {
						json=JSON.parse(msg);
					}
					_self.enableIniCheckBox=json.enableCheckBox;
					if(json.ageLimit == "false"){
						$("#nom_div_below_age").css("display", "block");
						$("#nom_div_above_age_limit").css("display", "none");
						$("#add-newnomineeform--button").prop( "disabled", true );
					} else {
						$("#nom_div_above_age_limit").css("display", "block");
						$("#nom_div_below_age").css("display", "none");
						$("#add-newnomineeform--button").prop( "disabled", false );
						if (json.enableCheckBox === "false") {	
							// $("#member-nominee-registration-userrequest .newnomineesucess-validation").html("Data deleted Successfully");
							// $("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "block");
							// $("#member-nominee-registration-userrequest .newnomineesucess-validation").css("color", "green");
							// $("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
							// $("#member-nominee-registration-userrequest .error-validation").css("display", "none");
							// $("#submissionID").val(json.submissionId);
							// $("." + cureentFormDataIdforhide).removeClass('hide');
							// $(".add-nomineeform--button"+ cureentFormDataId).removeClass('hide');
							//$("#nominee-form--cancel"+ cureentFormDataId).removeClass('hide');
							$(".checkbox_trigger").prop( "disabled", true );
							$(".contri-chekdisb-msg").css("display", "block");
						} else {
							// $("#member-nominee-registration-userrequest .error-validation").html("Unable to delete User Data Due to Some Network Problem!");
							// $("#member-nominee-registration-userrequest .error-validation").css("display", "block");
							// $("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
							// $("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "none");
							$(".checkbox_trigger").prop( "disabled", false );
							$(".contri-chekdisb-msg").css("display", "none");
							$('body').animate({
								'scrollTop': 100
							}, 500, function () { });
						}
					}						           
				}
			},
			error: function (error: any) {
				_self.bookingformcommon.preloaderClose();
				$("#member-nominee-registration-userrequest .error-validation").html("Sorry, network issue. Please try again later");
				$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
				$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
				$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
				$('body').animate({
					'scrollTop': 100
				}, 500, function () { });
			}
		});
	}
	// hideErrorValidation(): any {
	// 	let _self = this;
	// 	let form: any = $('#member-nominee-registration-userrequest');
	// 	let fileInputs: any = form.find('input[type="file"]');
	// 	$(".btn-member--nomineesave").click(function () {
	// 		var cureentFormDataIdforhide = $(this).attr('id');
	// 		var cureentFormDataId = $(this).attr('id').slice(-1);
	// 		let showedFiledsets = $("#nominee-form-filedset").children('fieldset').not("." + 'hide').length;
	// 		for (let i = showedFiledsets; i < 9; i++) {
	// 			$('.focus-member--nominee-type' + i).addClass('hide');
	// 			$('.focus-member-nominee--enrichid' + i).addClass('hide');
	// 			$('.focus-member-current--currentenrichid' + i).addClass('hide');
	// 			$('.focus-member--nominee-upload' + i).addClass('hide');
	// 			$('.focus-member--nominee-relation' + i).addClass('hide');
	// 			$('.focus-member--nominee-contri' + i).addClass('hide');
	// 			$('.focus-member--nominee-signedconsent' + i).addClass('hide');
	// 		}
	// 		if ($(".checkbox_trigger").is(':checked')) {
	// 			for(let i=0; i < 9; i++){
	// 			$('.focus-member--nominee-relation' + i).removeClass('hide');
	// 			$('.focus-member--nominee-contri' + i).removeClass('hide');
	// 			$('.focus-member--nominee-signedconsent' + i).removeClass('hide');
	// 			}
	// 		} else {
	// 			for(let i=0; i < 9; i++){
	// 			$('.focus-member--nominee-relation' + i).addClass('hide');
	// 			$('.focus-member--nominee-contri' + i).addClass('hide');
	// 			$('.focus-member--nominee-signedconsent' + i).addClass('hide');
	// 			// $('.focus-member--nominee-relation' + (cureentFormDataId-1)).addClass('hide');
	// 			// $('.focus-member--nominee-contri' + (cureentFormDataId-1)).addClass('hide');
	// 			// $('.focus-member--nominee-signedconsent' + (cureentFormDataId-1)).addClass('hide');
	// 			}
	// 		}
	// 		// var cureentFormDataIdforhide = $(this).attr('id');
	// 		var cureentFormDataId = $(this).attr('id').slice(-1);
	// 		let selectedparent = $(this).parents("fieldset");
	// 		let slectedvalue = $("#member--nominee-type" + cureentFormDataId).val();
	// 			if (slectedvalue == "" || slectedvalue == "New") {
	// 				for(let i=0; i < 9; i++){
	// 					$('.focus-member-current--currentenrichid' + i).addClass('hide');
	// 				}
	// 			} else {
	// 				for(let i=0; i < 9; i++){
	// 					$('.focus-member-current--currentenrichid' + i).addClass('hide');
	// 				}
	// 				$('.focus-member-current--currentenrichid' + cureentFormDataId).removeClass('hide');
	// 			}
	// 	});
	// }
	newNomineeFileSizeLimit(): void {
		$('INPUT[type="file"]').change(function () {
			var fileSize = this.files[0];
			var sizeInMb = fileSize.size/1024;
			var sizeLimit= 1024*5;
			if (sizeInMb > sizeLimit) {
				$('label.btn.btn-primary').attr('disabled', false);
			}
			else {
				$("#member-nominee-registration-userrequest .error-validation").html("Selected file size exceded 5MB !");
				$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
				$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
			}
		});
	}
	sendingNewNomineeData(): void {
		let _self = this;
		$(".btn-member--nomineesave").click(function ($instance: any) {
			$instance.preventDefault();
			var cureentFormDataIdforhide = $(this).attr('id');
			var cureentFormDataId = $(this).attr('id').slice(-1);
			let parentidfordisabeinputs = $("#" + cureentFormDataIdforhide).parent('fieldset').attr('id');
			let errorLength = $("#count-of-errorvalidation p").children('').not("." + 'hide').length;
			if (errorLength == 0) {
				$("#member-nominee-registration-userrequest .error-validation").html("");
				$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
				$("#member-nominee-registration-userrequest .error-validation").removeClass('mandatory-text');
				// let currentId=$(this).attr("id").slice(-1);
				var form = $('#member-nominee-registration-userrequest')[0];
				var formData = new FormData(form);
				formData.append("cureentFormDataId", cureentFormDataId);
				formData.append("submissionID", $('#submissionID').val());
				// bcommon.preloader();
				// $("#enrich-voucher-redemption .error-validation").html("");
				// $("#enrich-voucher-redemption .error-validation").css("display", "none");
				// $("#enrich-voucher-redemption .error-validation").removeClass('mandatory-text');
				let authenticationUrl: string = '';
				_self.bookingformcommon.preloader();
				if (window.location.hostname === 'localhost' && window.location.port == "5000") {
					authenticationUrl = '/dummy-data/newNomineeStatus.json';
				}
				else {
					authenticationUrl = '/bin/services/new/saveNomineeDtls';
				}
				$.ajax({
					type: 'POST',//Change to POST if required
					url: authenticationUrl,
					data: formData,
					processData: false,
					contentType: false,
					success: function (msg: any) {
						_self.bookingformcommon.preloaderClose();
						if (msg != "") {
							var json = msg;
							if (typeof msg === 'string') {
								json = JSON.parse(msg);
							}
							if (json.processCode === "OK") {
								$("#member-nominee-registration-userrequest .newnomineesucess-validation").html(json.succMsg);
								$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "block");
								$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("color", "green");
								$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
								$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
								$("#submissionID").val(json.submissionId);
								$("." + cureentFormDataIdforhide).addClass('hide');
								$("#nominee-form--cancel" + cureentFormDataId).addClass('hide');
								$(".btn-member--nomineeremove" + cureentFormDataId).removeClass('hide');
								// $("#" + cureentFormDataIdforhide).children.addClass('hide');
								$(".nominee-requestform--submit").removeClass('hide');
								$(".addnewnominee").removeClass('hide');
								$(".submitallsavednominees").removeClass('hide');
								$("#member--nominee-type" + cureentFormDataId).prop("disabled", true);
								$("#member-nominee--enrichid" + cureentFormDataId).prop("disabled", true);
								$("#member-current--currentenrichid" + cureentFormDataId).prop("disabled", true);
								$("#member--nominee-upload" + cureentFormDataId).prop("disabled", true);
								// $(".member--nominee-upload" + cureentFormDataId).prop( "disabled", true );
								$("#freinds-familynominee" + cureentFormDataId).prop("disabled", true);
								$("#member--nominee-relation" + cureentFormDataId).prop("disabled", true);
								$("#member--nominee-contri" + cureentFormDataId).prop("disabled", true);
								$("#member--nominee-signedconsent" + cureentFormDataId).prop("disabled", true);
								// $("member--nominee-signedconsent" + cureentFormDataId).prop( "disabled", true );
								// $( "#new-nominee" +  cureentFormDataId).prop( "disabled", true );

								// let hiddenSubmissionID = json.submissionId;		
								// let isUserLoggedIn = _self.getCookie("p_loggedinuser");
								// $.magnificPopup.open({
								// 	items: {
								// 		src: '#newnominee-voucher-success-popup'
								// 	},
								// 	type: 'inline',
								// 	midClick: true,
								// 	enableEscapeKey: false,
								// 	showCloseBtn: false,
								// 	closeOnBgClick: false,
								// 	modal: true,
								// 	callbacks: {
								// 		open: function () {
								// 			var $content = $(this.content);
								// 			$content.on('click', '.msg-btn-cancel', function () {
								// 				$.magnificPopup.close();
								// 			});
								// 		}
								// 	}
								// }, 0);
							} else {
								$("#member-nominee-registration-userrequest .error-validation").html(json.succMsg);
								$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
								$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
								$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
								$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "none");
								$('body').animate({
									'scrollTop': 100
								}, 500, function () { });
								// $.magnificPopup.open({
								// 	items: {
								// 		src: '#newnominee-voucher-failure-popup'
								// 	},
								// 	type: 'inline',
								// 	midClick: true,
								// 	enableEscapeKey: false,
								// 	showCloseBtn: false,
								// 	closeOnBgClick: false,
								// 	modal: true,
								// 	callbacks: {
								// 		open: function () {
								// 			var $content = $(this.content);
								// 			$content.on('click', '.msg-btn-cancel', function () {
								// 				$.magnificPopup.close();
								// 			});
								// 		}
								// 	}
								// }, 0);
							}
						}
					},
					error: function (error: any) {
						_self.bookingformcommon.preloaderClose();
						$("#member-nominee-registration-userrequest .error-validation").html("Sorry, network issue. Please try again later");
						$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
						$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
						$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
						$('body').animate({
							'scrollTop': 100
						}, 500, function () { });
					}
				});
			}
		});
	}
	cancelNewNomineeData(): void {
		let _self = this;
		$(".btn-member--nomineecancel").click(function ($instance: any) {
			$instance.preventDefault();
			var cureentFormDataIdforhide = $(this).attr('id');
			var cureentFormDataId = $(this).attr('id').slice(-1);
			let selectedparent = $(this).parents("fieldset").attr('id');
			let parentidfordisabeinputs = $("#" + cureentFormDataIdforhide).parent('fieldset').attr('id');
			$("#member--nominee-type" + cureentFormDataId).val("");
			$("#member-nominee--enrichid" + cureentFormDataId).val("");
			$("#member-current--currentenrichid" + cureentFormDataId).val("");
			$("#member--nominee-upload" + cureentFormDataId).val("");
			// $("input.form-control").val("");
			// $(".member--nominee-upload" + cureentFormDataId).prop( "disabled", true );
			$("#freinds-familynominee" + cureentFormDataId).val("");
			$("#member--nominee-relation" + cureentFormDataId).val("");
			$("#member--nominee-contri" + cureentFormDataId).val("");
			$("#member--nominee-signedconsent" + cureentFormDataId).val("");
			$("#" + selectedparent).addClass("hide");
			if(cureentFormDataId == 0){
				$(".nominee-requestform--submit").removeClass("hide");
			} else {
				$(".nominee-requestform--submit").removeClass("hide");
				$(".submitallsavednominees").removeClass("hide");
			}
		});
	}
	// onReplacementSelect(nomineeId:any): void{
	// 	let _self = this;
	// 	let nomineeTable = $("#nominee-table")
	// 	_self.nomineesOptionsData = _self.nomineeData.filter((elm:any) => elm.nominneId!=nomineeId)
	// 	// _self.populateTable(nomineeTable,nominees,true);
	// }
	// removeNewNomineeAppendeform(): void {
	// 	$("body").on("click", ".btn-member--nomineeremove", function () {
	// 		$(this).closest(".nominee-getting.panel").addClass('hide');
	// 		let showedfieldsets = $("#nominee-form-filedset").children('fieldset').not("." + 'hide').length;
	// 		if (showedfieldsets == 9) {
	// 			$('#add-nomineeform--button').addClass('hide');
	// 		} else {
	// 			$('#add-nomineeform--button').removeClass('hide');
	// 		}
	// 	});
	// }
	submitAllSavedNominees(): any {
		let _self = this;
		var _current = this
		$("#nominee-form--submitsavednominees").click(function (event: any) {
			// let bcommon = _self.bookingformcommon;
			event.preventDefault();
			$.magnificPopup.open({
				items: {
					src: '#nominee-submitall-success-popup-msg'
				},
				type: 'inline',
				midClick: true,
				enableEscapeKey: false,
				showCloseBtn: false,
				closeOnBgClick: false,
				modal: true,
				callbacks: {
					open: function () {
						var $content = $(this.content);
						$content.on('click', '.msg-btn-confirm', function () {
							$.magnificPopup.close();
			$("#member-nominee-registration-userrequest .error-validation").html("");
			$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
			$("#member-nominee-registration-userrequest .error-validation").removeClass('mandatory-text');
			_self.bookingformcommon.preloader();
			// let submissonid:any = $("#submissionID").val();
			let data = { 
							submissionid: $('#submissionID').val(),
							'source_submit':'Nominee-App'
					   };
			let authenticationUrl: string = '';
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				authenticationUrl = '/dummy-data/newNomineeStatus.json';
			}
			else {
				authenticationUrl = '/bin/services/new/submitNomineeDtls';
			}

			$.ajax({
				type: 'POST',//Change to POST if required
				url: authenticationUrl,
				data: data,
				success: function (msg: any) {
					_self.bookingformcommon.preloaderClose();
					if (msg != "") {
						var json = msg;
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						}
						if (json.processCode === "OK") {
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").html(json.succMsg);
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "block");
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("color", "green");
							$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
							$(".nominee-requestform--submit").addClass('hide');
							$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
							$.magnificPopup.open({
									items: {
										src: '#newnominee-voucher-success-popup'
									},
									type: 'inline',
									midClick: true,
									enableEscapeKey: false,
									showCloseBtn: false,
									closeOnBgClick: false,
									modal: true,
									callbacks: {
										open: function () {
											var $content = $(this.content);
											$content.on('click', '.msg-btn-cancel', function () {
												$.magnificPopup.close();
												location.reload();
											});
										}
									}
								}, 0);
						} else {
							$("#member-nominee-registration-userrequest .error-validation").html(json.succMsg);
							$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
							$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
							$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "none");
							$('body').animate({
								'scrollTop': 100
							}, 500, function () { });
							$.magnificPopup.open({
									items: {
										src: '#newnominee-voucher-failure-popup'
									},
									type: 'inline',
									midClick: true,
									enableEscapeKey: false,
									showCloseBtn: false,
									closeOnBgClick: false,
									modal: true,
									callbacks: {
										open: function () {
											var $content = $(this.content);
											$content.on('click', '.msg-btn-cancel', function () {
												$.magnificPopup.close();
											});
										}
									}
								}, 0);
						}
					}
				},
				error: function (error: any) {
					_self.bookingformcommon.preloaderClose();
					$("#member-nominee-registration-userrequest .error-validation").html("Sorry, network issue. Please try again later");
					$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
					$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
					$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
					$('body').animate({
						'scrollTop': 100
					}, 500, function () { });
				}
			});
						});
						$content.on('click', '.msg-btn-cancel', function () {
							$.magnificPopup.close();
						});
					}
				}
			}, 0);
		});
	}
	removeNewNomineeData(): void {
		let _self = this;
		$(".btn-member--nomineeremove").click(function ($instance: any) {
			$instance.preventDefault();
			$("#member-nominee-registration-userrequest .error-validation").html("");
			$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
			$("#member-nominee-registration-userrequest .error-validation").removeClass('mandatory-text');
			var cureentFormDataIdforhide = $(this).attr('id');
			var cureentFormDataId = $(this).attr('id').slice(-1);
			let selectedparent = $(this).parents("fieldset").attr('id');
			let parentidfordisabeinputs = $("#" + cureentFormDataIdforhide).parent('fieldset').attr('id');
			// let currentId=$(this).attr("id").slice(-1);
			var form = $('#member-nominee-registration-userrequest')[0];
			var formData = new FormData(form);
			formData.append("cureentFormDataId", cureentFormDataId);
			formData.append("submissionID", $('#submissionID').val());
			formData.append("nomineeID", $('#member-nominee--enrichid' + cureentFormDataId).val());
			// bcommon.preloader();
			// $("#enrich-voucher-redemption .error-validation").html("");
			// $("#enrich-voucher-redemption .error-validation").css("display", "none");
			// $("#enrich-voucher-redemption .error-validation").removeClass('mandatory-text');
			let authenticationUrl: string = '';
			_self.bookingformcommon.preloader();
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				authenticationUrl = '/dummy-data/newNomineeStatus.json';
			}
			else {
				authenticationUrl = '/bin/services/new/removeNomineeDtls';
			}
			$.ajax({
				type: 'POST',//Change to POST if required
				url: authenticationUrl,
				data: formData,
				processData: false,
				contentType: false,
				success: function (msg: any) {
					_self.bookingformcommon.preloaderClose();
					if (msg != "") {
						var json = msg;
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						}
						if (json.processCode === "OK") {
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").html(json.succMsg);
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "block");
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("color", "green");
							$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
							$("#member-nominee-registration-userrequest .error-validation").css("display", "none");
							$("#submissionID").val(json.submissionId);
							$("." + cureentFormDataIdforhide).removeClass('hide');
							$(".add-nomineeform--button" + cureentFormDataId).removeClass('hide');
							$("#nominee-form--cancel" + cureentFormDataId).removeClass('hide');
							//$("#nominee-form--cancel"+ cureentFormDataId).removeClass('hide');
							$(".btn-member--nomineeremove" + cureentFormDataId).addClass('hide');
							$("#member--nominee-type" + cureentFormDataId).prop("disabled", false);
							$("#member-nominee--enrichid" + cureentFormDataId).prop("disabled", false);
							$("#member-current--currentenrichid" + cureentFormDataId).prop("disabled", false);
							$("#member--nominee-upload" + cureentFormDataId).prop("disabled", false);
							// $("input.form-control").prop("disabled", false);
							if(_self.enableIniCheckBox === "false"){
								$("#freinds-familynominee" + cureentFormDataId).prop("disabled", true);
							} else {
								$("#freinds-familynominee" + cureentFormDataId).prop("disabled", false);
							}
							$("#member--nominee-relation" + cureentFormDataId).prop("disabled", false);
							$("#member--nominee-contri" + cureentFormDataId).prop("disabled", false);
							$("#member--nominee-signedconsent" + cureentFormDataId).prop("disabled", false);
							$("#new-nominee" + (cureentFormDataId + 1)).addClass('hide');
							$("#member--nominee-type" + cureentFormDataId).val("");
							$("#member-nominee--enrichid" + cureentFormDataId).val("");
							$("#member-current--currentenrichid" + cureentFormDataId).val("");
							$("#member--nominee-upload" + cureentFormDataId).val("");
							// $("input.form-control").val("");
							// $(".member--nominee-upload" + cureentFormDataId).prop( "disabled", true );
							$("#freinds-familynominee" + cureentFormDataId).val("");
							$("#member--nominee-relation" + cureentFormDataId).val("");
							$("#member--nominee-contri" + cureentFormDataId).val("");
							$("#member--nominee-signedconsent" + cureentFormDataId).val("");
							//$("#" + selectedparent).addClass('hide');
						} else {
							$("#member-nominee-registration-userrequest .error-validation").html(json.succMsg);
							$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
							$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
							$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
							$("#member-nominee-registration-userrequest .newnomineesucess-validation").css("display", "none");
							$('body').animate({
								'scrollTop': 100
							}, 500, function () { });
						}
					}
				},
				error: function (error: any) {
					_self.bookingformcommon.preloaderClose();
					$("#member-nominee-registration-userrequest .error-validation").html("Sorry, network issue. Please try again later");
					$("#member-nominee-registration-userrequest .error-validation").css("display", "block");
					$("#member-nominee-registration-userrequest .error-validation").css("color", "#ed1c24");
					$("#member-nominee-registration-userrequest .error-validation").addClass('mandatory-text');
					$('body').animate({
						'scrollTop': 100
					}, 500, function () { });
				}
			});
		});
	}
}

let scope: Element = document.querySelector('#nominee-mob');
if (scope) {
	try {
		let membernominee = new memberNominee();
		membernominee.initTextInputs();
		membernominee.validateForm();
		membernominee.populateNominees();
		membernominee.handleNomineeStatus();
		membernominee.nomineeCheckboxBasedShowAndhideForm();
		membernominee.nomineeTypeBasedshowhide();
		membernominee.addNewNominee();
		membernominee.enableCheckBoxs();
		//membernominee.newNomineeFileSizeLimit();
		// membernominee.hideErrorValidation();
		membernominee.sendingNewNomineeData();
		membernominee.cancelNewNomineeData();
		// membernominee.removeNewNomineeAppendeform();
		membernominee.submitAllSavedNominees();
		membernominee.removeNewNomineeData();
		// membernominee.popupHandling();
	} catch (e) { console.error(e); }
}